const constants = {
  MAX_LENGTH_CONSTRAINTS: {
    ADD_PRO_NOTES: {
      COMMENT: 6000
    }
  }
};

export default constants;
